module.exports = __webpack_public_path__ + "img/gripWrench.6b3eff3a.png";